<div class="container">
  @if (isSecondUser) {
    <div class="banner-data">
      <span class="info-circle" nz-icon nzType="info-circle" nzTheme="fill"></span>
      <p>
        {{'toastr.paymentMethod.profile' | translate}} <b>{{ userData?.name }} {{ userData?.surname }}</b
        >, {{'toastr.paymentMethod.clickProfile' | translate}} <a (click)="changeUser()">{{'toastr.paymentMethod.here' | translate}}</a>
      </p>
    </div>
  }

  <div class="title-divider">
    <h2>{{ 'personalArea.paymentMethods.title' | translate }}</h2>
    <nz-divider></nz-divider>
  </div>

  <app-appointments-table
    [searchEnabled]="true"
    [innerFiltersEnabled]="true"
    [hasCheckbox]="false"
    [hiddenLastSegment]="true"
    (actionClicked)="openPaymentDetail($event)"
    [columns]="columns"
    [appointments]="payments"
    [appointmentText]="appointmentsText"
    [innerSelectData]="filters.innerSelectData"
  ></app-appointments-table>
</div>
